import React, { Component } from 'react';
import Cropper from 'react-cropper';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import 'cropperjs/dist/cropper.css'; // see installation section above for versions of NPM older than 3.0.0
import SystemLabel from '../../system/SystemLabel/SystemLabel';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import CropRotateIcon from '@material-ui/icons/CropRotate';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

class ImageCropper extends Component {
    state = {
        dropdownOpen: false,
        aspectRatio: 16 / 9
    };
    _crop() {
        // image in dataUrl
        /*     this.refs.cropper.getCroppedCanvas().toDataURL()); */
    }
    _rotate() {
        this.refs.cropper.rotate(-90);
    }
    _aspectRatio = (ratio) => {
        this.refs.cropper.setAspectRatio(ratio);
    }
    _saveChanges() {
        const b64 = this.refs.cropper.getCroppedCanvas().toDataURL()
        this.props.onSave(b64);
    }
    _toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    _close() {
        this.props.close();
    }
    render() {
        const { url } = this.props;
        const { aspectRatio } = this.state;
        const cropSizes = this.props.cropSizes || null;
        return (
            <Modal isOpen={true} toggle={this.props.close} >
                <ModalHeader toggle={this.toggle}><i className="fa fa-crop" /> {" "} <SystemLabel name="Crop" /></ModalHeader>
                <ModalBody>
                    <Cropper
                        ref='cropper'
                        src={url}
                        style={cropSizes ? { height: cropSizes.height, width: '100%' } : { height: 400, width: '100%' }}
                        // Cropper.js options
                        crossOrigin="anonymous"
                        height={180}
                        aspectRatio={aspectRatio}
                        guides={true}
                        crop={this._crop.bind(this)} />
                </ModalBody>
                <ModalFooter>
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this._toggle.bind(this)}>
                        <DropdownToggle caret>
                            <AspectRatioIcon />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this._aspectRatio(1 / 1)} >1:1 <SystemLabel name="Square" /></DropdownItem>
                            <DropdownItem onClick={() => this._aspectRatio(4 / 3)}>4:3 <SystemLabel name="Standard" /></DropdownItem>
                            <DropdownItem onClick={() => this._aspectRatio(16 / 9)}>16:9 <SystemLabel name="Standard" /></DropdownItem>
                        </DropdownMenu>
                    </Dropdown>{' '}
                    <Button color="secondary" onClick={this._rotate.bind(this)}><CropRotateIcon /></Button>{' '}
                    <Button color="primary" onClick={this._saveChanges.bind(this)}><SaveIcon /> </Button>{' '}
                    <Button color="secondary" onClick={this._close.bind(this)}><CloseIcon /></Button>
                </ModalFooter>
            </Modal>

        );
    }
}

export default ImageCropper;
